import {
  Component,
  OnInit,
  OnDestroy,
  ElementRef,
  ViewEncapsulation,
} from "@angular/core";
import { Subscription } from "rxjs";

import { LocalizeService } from "../../insa-services";
import { ControlTableService } from "./control-table.service";
import { Watchlist, isFavouritesWatchlist } from "./control-table.models";

@Component({
  selector: "app-control-table-admin",
  templateUrl: "./control-table-admin.component.html",
  styles: [require("./control-table.component.css").toString()],
  encapsulation: ViewEncapsulation.None,
})
export class ControlTableAdminComponent implements OnInit, OnDestroy {
  watchlists: Watchlist[] = [];
  newName = "";
  busy = false;
  errorMsg = "";

  editingId: number | null = null;
  editingName = "";

  confirmDeleteId: number | null = null;

  private sub: Subscription;

  constructor(
    private _localize: LocalizeService,
    private _element: ElementRef,
    private _service: ControlTableService,
  ) {}

  ngOnInit(): void {
    this.sub = this._service.watchlists.subscribe((watchlists) => {
      this.watchlists = watchlists;
      this.reapplyLocalize();
    });
    this._service.loadWatchlists();
  }

  ngOnDestroy(): void {
    if (this.sub) this.sub.unsubscribe();
  }

  isFavourites(w: Watchlist): boolean {
    return isFavouritesWatchlist(w.WatchlistID);
  }

  get namePlaceholder(): string {
    return this._localize.getLocalizedResource("Res1641") || "Naziv liste";
  }

  displayName(w: Watchlist): string {
    if (this.isFavourites(w))
      return this._localize.getLocalizedResource("Res3676") || "Favoriti";
    return w.WatchlistName;
  }

  createTable(): void {
    const name = this.newName.trim();
    if (!name || this.busy) return;
    this.busy = true;
    this.errorMsg = "";
    this._service.createWatchlist(name).subscribe((created) => {
      this.busy = false;
      if (created) {
        this.newName = "";
        this._service.loadWatchlists();
      } else {
        this.errorMsg =
          this._localize.getLocalizedResource("Res1598") ||
          "Kreiranje liste nije uspelo.";
      }
    });
  }

  startRename(w: Watchlist): void {
    if (this.isFavourites(w)) return;
    this.editingId = w.WatchlistID;
    this.editingName = w.WatchlistName;
  }

  cancelRename(): void {
    this.editingId = null;
    this.editingName = "";
  }

  saveRename(): void {
    if (this.editingId == null) return;
    const name = this.editingName.trim();
    if (!name) return;
    const id = this.editingId;
    this._service.renameWatchlist(id, name).subscribe((res) => {
      if (res && res.success) this._service.loadWatchlists();
      else
        this.errorMsg =
          (res && res.description) ||
          this._localize.getLocalizedResource("Res1599") ||
          "Preimenovanje nije uspelo.";
    });
    this.cancelRename();
  }

  askDelete(w: Watchlist): void {
    if (this.isFavourites(w)) return;
    this.confirmDeleteId = w.WatchlistID;
  }

  cancelDelete(): void {
    this.confirmDeleteId = null;
  }

  confirmDelete(): void {
    if (this.confirmDeleteId == null) return;
    const id = this.confirmDeleteId;
    this.confirmDeleteId = null;
    this._service.deleteWatchlist(id).subscribe((res) => {
      if (res && res.success) this._service.loadWatchlists();
      else
        this.errorMsg =
          (res && res.description) ||
          this._localize.getLocalizedResource("Res1635") ||
          "Brisanje nije uspelo.";
    });
  }

  private reapplyLocalize(): void {
    setTimeout(
      () => this._localize.applyTranslations(this._element.nativeElement),
      0,
    );
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-control-table/control-table-admin.component.ts